(function ($) {

  var $navSwitch = $('.c-navigation-switch [data-opens-menu]');

  $navSwitch.on("click", function () {
    $('.c-primary-navigation').toggleClass('is-open');
    $('.c-toolbar__switch').toggleClass('is-nav-open');
    // $('.c-overlay').toggleClass('is-visible');

  });

})(jQuery);